import { render, staticRenderFns } from "./ReturnLabelCreationModal.vue?vue&type=template&id=0569ae6f"
import script from "./ReturnLabelCreationModal.vue?vue&type=script&lang=js"
export * from "./ReturnLabelCreationModal.vue?vue&type=script&lang=js"
import style0 from "./ReturnLabelCreationModal.vue?vue&type=style&index=0&id=0569ae6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports